import { getAuth } from "firebase/auth";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

/**
 * Preview CSV: returns headers and sample rows (no mapping).
 * @param {File} file
 */
export async function previewRentRoll(file) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  if (!token) throw new Error("Not authenticated");

  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${API_BASE_URL}/import/rent-roll`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Preview failed");
  }
  return data;
}

/**
 * Commit import with column mapping.
 * @param {File} file
 * @param {Record<string, string>} mapping - field key → exact CSV header string
 */
export async function commitRentRoll(file, mapping) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  if (!token) throw new Error("Not authenticated");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("mapping", JSON.stringify(mapping));

  const res = await fetch(`${API_BASE_URL}/import/rent-roll`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "Import failed");
  }
  return data;
}

/**
 * AI-assisted mapping: returns suggested field->header mapping for required fields.
 * @param {File} file
 */
export async function aiMapRentRoll(file) {
  const user = getAuth().currentUser;
  const token = user ? await user.getIdToken() : null;
  if (!token) throw new Error("Not authenticated");

  const formData = new FormData();
  formData.append("file", file);

  const res = await fetch(`${API_BASE_URL}/import/rent-roll/ai-normalize`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || "AI mapping failed");
  }
  return data;
}
